export default "__VITE_ASSET__cec4b32b__"